import { render, staticRenderFns } from "./ChangeWatcherAlert.vue?vue&type=template&id=45e2ee6c&"
import script from "./ChangeWatcherAlert.vue?vue&type=script&lang=js&"
export * from "./ChangeWatcherAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports